import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth.module';
import benefits from './modules/benefits.module';
import benefitsUsage from './modules/benefitsUsage.module';
import categories from './modules/categories.module';
import consents from './modules/consents.module';
import notification from './modules/notification.module';
import settings from './modules/settings.module';
import system from './modules/system.module';
import terms from './modules/terms.module';
import profile from './modules/profile.module';

// TODO : wczytywanie modułów do sklepu powinno być automatyczne. Wszystkie pliki w ./modules

Vue.use(Vuex);
// Create a new store

const store = new Vuex.Store({
  actions: {},
  getters: {},
  mutations: {},
  state: {},
  modules: {
    auth,
    benefits,
    categories,
    consents,
    benefitsUsage,
    notification,
    system,
    settings,
    terms,
    profile
  }
});

export default store;
